import {Component, Input, OnInit} from '@angular/core';
import {V3Correction, V3ExerciseSessionQuestionBase} from "../../../model/v3/cspa";

@Component({
    selector: 'app-cor-result',
    templateUrl: './cor-result.component.html',
    styleUrls: ['./cor-result.component.scss'],
    standalone: false
})
export class CorResultComponent implements OnInit {
  @Input() questions: V3ExerciseSessionQuestionBase<V3Correction>[]

  constructor() { }

  ngOnInit(): void {
  }

  getCorrectAnswer(q: V3ExerciseSessionQuestionBase<V3Correction>) {
    return q.questionDef.answerDef.correct
  }

  getStudentAnswer(q: V3ExerciseSessionQuestionBase<V3Correction>) {
    return q.questionDef.answerDef.answerHolder?.response || "-"
  }

  isIncorrect(q: V3ExerciseSessionQuestionBase<V3Correction>) {
    return !q.isCorrect
  }
}
